/**
 * Copyright © 2026 Adnuntius AS.
 */
import {Component} from '@angular/core';
import template from './layout-example-list-page.component.html';

import {ALL_LAYOUTS} from './examples/all-layouts';
import {APP_SHARED} from '../../common/app-shared';
import {UIRouterModule} from '@uirouter/angular';

@Component({
  standalone: true,
  imports: [...APP_SHARED, UIRouterModule],
  selector: 'adn-layout-example-list-page',
  template
})
export class LayoutExampleListPageComponent {
  readonly allLayouts = ALL_LAYOUTS;
}
